import { graphql } from 'react-relay';

import { StoreStuffWindowPaginator_query$key } from '../../../relay/__generated__/StoreStuffWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const StoreStuffWindowPaginator_query = graphql`
  fragment StoreStuffWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: StoreStuffFilter }
    order: { type: StoreStuffOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "StoreStuffWindowPaginatorRefreshQuery") {
    storeStuffs(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...StoreStuffConnectionDataTable_storeStuffConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<StoreStuffWindowPaginator_query$key>, 'fragment'>;

const StoreStuffWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={StoreStuffWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.storeStuffs.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default StoreStuffWindowPaginator;
